import script from "./SubtaskResults.vue?vue&type=script&setup=true&lang=js"
export * from "./SubtaskResults.vue?vue&type=script&setup=true&lang=js"

import "./SubtaskResults.vue?vue&type=style&index=0&id=19eb102e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19eb102e"]])

export default __exports__